<template>
  <div />
</template>

<script>
import { getScrollDistance } from "../constants/scroll";

export default {
  name: "ScrollControls",
  mounted() {
    window.addEventListener("wheel", this.scrollwheel);
  },
  beforeDestroy() {
    window.removeEventListener("wheel", this.scrollwheel);
  },
  methods: {
    scrollwheel(e) {
      if (this.$route.name === "narrative") return;

      let scrollAmount = getScrollDistance(e);
      if (this.$store.state.geolocation.flipped) scrollAmount *= -1;

      this.$store.commit("setDirection", scrollAmount >= 0 ? 1 : -1);

      let newLocation = this.$store.state.geolocation.location + scrollAmount;
      this.$store.commit("setLocation", newLocation);
    }
  }
};
</script>
